export default __webpack_public_path__ + "static/media/link-results.4c391b9e.png";